import { render, staticRenderFns } from "./error.vue?vue&type=template&id=4e935a59&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=ts&"
export * from "./error.vue?vue&type=script&lang=ts&"
import style0 from "./error.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./error.vue?vue&type=style&index=1&id=4e935a59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e935a59",
  null
  
)

export default component.exports